import React, {useEffect, useState} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import CardMenu from '../../../components/CardMenu/CardMenu'
import {Link, useHistory} from 'react-router-dom'
import DarkAgregarProducto from '../../../media/felsv/dark_product_icon.svg'
import WhiteAgregarProducto from '../../../media/felsv/white_product_icon.svg'
import { KEYS } from '../../../constants/keysStorage'

const GPDashboard = () => {
  const [activo, setActivo] = useState(0)
  const history = useHistory();

  useEffect(() => {
    window.scroll(0, 0)
    let rol = localStorage.getItem(KEYS.ROL)?.toString() || '0'
    if (rol !== '2') { history.push("/home"); }
  }, [])

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to='/home' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Gestión de productos</h3>
      </div>
      <div className='separador'></div>
      <div className='home-dashboard wf-layout-layout flex flex-col w-full'>
        <div className='home-dashboard wf-layout-layout'>
          <CardMenu
            to='/gestion-productos/agregar-producto'
            activar={() => setActivo(1)}
            desactivar={() => setActivo(0)}
            activo={activo === 1}
            WhiteIcon={WhiteAgregarProducto}
            DarkIcon={DarkAgregarProducto}
            title='Agregar productos'
            description='Con esta funcionalidad, los usuarios pueden agregar productos de manera rápida, asignarlos a sucursales específicas, gestionar precios y tipos de producto, y garantizar que toda la información del catálogo esté actualizada y disponible para los distintos procesos del sistema.'
            autoFocus={true}
          />
          <CardMenu
            to='/gestion-productos/listar-productos'
            activar={() => setActivo(2)}
            desactivar={() => setActivo(0)}
            activo={activo === 2}
            WhiteIcon={WhiteAgregarProducto}
            DarkIcon={DarkAgregarProducto}
            title='Lista de productos'
            description='Esta pantalla ofrece las herramientas necesarias para realizar el mantenimiento completo de todos los productos registrados en el sistema. Desde aquí, se pueden consultar, actualizar o eliminar productos según sea necesario.'
          />
        </div>
        
      </div>
    </BasicLayout>
  )
}

export default GPDashboard
